import { observer } from 'mobx-react-lite'
import { Avatar, Icon, Typography } from 'shared/ui'
import { SearchTypesEnum } from 'widgets/SearchDropdown'
import type { AnalyticsComparisonEntity } from 'pages/analytics/store/analyticsComparisonTableStore'
import styles from './styles.module.scss'

export interface IBreakdownEntityCellProps {
  filterType: SearchTypesEnum | null
  breakdownEntity?: AnalyticsComparisonEntity
  fallbackName: string
}

export const BreakdownEntityCell = observer(
  ({ filterType, breakdownEntity, fallbackName }: IBreakdownEntityCellProps) => {
    if (
      filterType === SearchTypesEnum.members &&
      breakdownEntity &&
      'full_name' in breakdownEntity
    ) {
      const { full_name } = breakdownEntity

      return (
        <div className={styles.cell}>
          <Avatar size={16} info={breakdownEntity?.avatarInfo} />
          <Typography variant='body-md-regular' color='primary' ellipsis ariaLabel='MemberName'>
            {full_name}
          </Typography>
        </div>
      )
    }

    if (
      filterType === SearchTypesEnum.tags &&
      breakdownEntity &&
      'color' in breakdownEntity &&
      'label' in breakdownEntity
    ) {
      return (
        <div className={styles.cell}>
          <div className={styles.tagColor} style={{ backgroundColor: breakdownEntity.color }} />
          <Typography variant='body-md-regular' color='primary' ellipsis ariaLabel='TagName'>
            {breakdownEntity.name}
          </Typography>
        </div>
      )
    }

    if (filterType === SearchTypesEnum.teams && breakdownEntity && 'name' in breakdownEntity) {
      return (
        <div className={styles.cell}>
          <Icon icon='inboxes2' tertiary />
          <Typography variant='body-md-regular' color='primary' ellipsis ariaLabel='TeamName'>
            {breakdownEntity.name}
          </Typography>
        </div>
      )
    }

    if (
      filterType === SearchTypesEnum.numbers &&
      breakdownEntity &&
      'formatted_number' in breakdownEntity
    ) {
      return (
        <div className={styles.cell}>
          <Icon icon={'phone'} tertiary />
          <Typography variant='body-md-regular' color='primary' ellipsis ariaLabel='NumberValue'>
            {breakdownEntity.formatted_number}
          </Typography>
        </div>
      )
    }

    if (
      filterType === SearchTypesEnum.outbound_sources &&
      breakdownEntity &&
      'label' in breakdownEntity &&
      'key' in breakdownEntity
    ) {
      return (
        <div className={styles.cell}>
          <Icon icon={'send'} tertiary />
          <Typography
            variant='body-md-regular'
            color='primary'
            ellipsis
            ariaLabel='OutboundSourceLabel'
          >
            {breakdownEntity.label}
          </Typography>
        </div>
      )
    }

    return (
      <Typography variant='body-md-regular' color='primary' ellipsis ariaLabel='BreakdownName'>
        {fallbackName}
      </Typography>
    )
  }
)
